import React from 'react';
import Select from 'react-select';

const MultiSelect = ({ 
  onChangeHandler, 
  handleMultiChange, 
  list, 
  inputRef, 
  name, 
  styles, 
  prefixStyles, 
  selectValue, 
  inputValue, 
  indicator = true, 
  defaultValue, 
  check = true,
  placeholder,
}) => {
  return (
    <>
      <Select
        isMulti
        onInputChange={(event, action) => onChangeHandler(event, name, action)}
        onChange={handleMultiChange}
        name={name}
        id={name}
        value={selectValue}
        ref={inputRef}
        options={list}
        className={styles}
        classNamePrefix={prefixStyles}
        inputValue={inputValue}
        defaultValue={defaultValue}
        components={!indicator && { DropdownIndicator:() => null, IndicatorSeparator:() => null }}
        isClearable={false}
        isDisabled={!check}
        placeholder={placeholder}
      />
    </>
  )
}

export default MultiSelect;